import { memo } from "react"

import { SelectOption } from "../ui/combobox"
interface SelectedLabelsProps<TValue extends React.Key | null | undefined> {
  selected: SelectOption<TValue>[]
}

export const SelectedLabels = memo(function SelectedBadges<
  TValue extends React.Key | null | undefined,
>({ selected }: SelectedLabelsProps<TValue>) {
  return (
    <ul className="contents" aria-label="Selected">
      {selected.map((item) => (
        <li
          key={item.value}
          className="bg-primary text-primary-foreground hover:bg-primary/90 inline-flex justify-between rounded-md p-1 text-xs"
        >
          {item.label}
        </li>
      ))}
    </ul>
  )
}) as <TValue extends React.Key | null | undefined>(
  props: SelectedLabelsProps<TValue>,
) => React.ReactElement
